import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Observable } from 'rxjs'
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront'
import { GlobalMessageService } from '@spartacus/core'
import {
  ActiveCartFacade,
  PromotionLocation,
  PromotionResult,
  Cart,
} from '@spartacus/cart/base/root'
import { FormGroup, FormControl } from '@angular/forms'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { CommonService } from '../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'app-add-bom-to-cart',
  templateUrl: './add-bom-to-cart.component.html',
  styleUrls: ['./add-bom-to-cart.component.scss'],
})
export class AddBomToCartComponent implements OnInit {
  iconTypes = ICON_TYPE

  entry$: Observable<any>
  cart$: Observable<Cart>
  loaded$: Observable<boolean>
  increment: boolean
  orderPromotions$: Observable<PromotionResult[]>
  promotionLocation: PromotionLocation = PromotionLocation.ActiveCart
  BOMPRoductList
  quantity = 1
  modalIsOpen = false

  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef

  form: FormGroup = new FormGroup({})

  private quantityControl$: Observable<FormControl>
  productlist: any[]

  constructor(
    protected launchDialogService: LaunchDialogService,
    protected cartService: ActiveCartFacade,
    public commonService: CommonService
  ) {}

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.BOMPRoductList = data.BOMPRoductList
    })
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      reason: reason,
      type: VS_LAUNCH_CALLER.ADD_BOM_TO_CART,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
